module.exports = "/static/assets/25eac09980011373fca550b4f97acc07.png";